var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 29,
    viewBox: "0 0 118 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4263 18.2768C35.0353 19.6738 33.0783 17.9418 30.6753 20.0098C30.6753 20.0098 35.3143 5.53281 43.1953 2.34781C43.1953 2.34781 48.4493 0.111811 51.9143 3.18581C55.3803 6.25981 47.4433 9.94881 47.4433 9.94881C47.4433 9.94881 51.4673 18.1648 44.2573 19.3948C44.2573 19.3948 40.2893 20.0098 39.6743 19.0598C39.6743 19.0598 47.6113 15.3708 43.4743 10.3398C43.4743 10.3398 50.4613 6.70681 48.2253 3.29781C48.2253 3.29781 46.4373 2.06781 44.2573 3.96781C44.3693 3.96781 37.7743 10.5638 35.4263 18.2768Z",
    fill: "#D12027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8772 9.22207C54.8772 9.22207 49.6792 11.1791 49.9592 17.8291C49.9592 17.8291 51.0212 20.1771 52.6412 19.5621C52.6412 19.5621 51.4672 17.1031 57.3922 9.72507C57.3922 9.78107 57.3922 8.88707 54.8772 9.22207Z",
    fill: "#D12027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1489 9.61374C63.1489 9.61374 64.2109 9.72574 63.3169 11.2347L59.3479 19.3387L63.1489 19.0597L67.1169 11.5697C67.1169 11.5697 68.0669 10.1727 69.2969 9.83774C69.2969 9.83774 70.5829 9.55774 70.0799 10.9547L66.7819 17.7737C66.7819 17.7737 66.1679 21.0157 69.7999 19.7297C69.7999 19.7297 72.9299 18.5567 74.1599 16.2647C74.1599 16.2647 69.1859 20.7367 70.0239 17.6067L73.2099 11.7377C73.2099 11.7377 74.4949 10.0047 71.5889 8.88674C71.5889 8.88674 68.2909 8.60774 67.7319 10.1167C67.7319 10.1167 65.9999 7.76874 64.0989 8.49574C64.0989 8.49574 63.6519 9.27874 62.5339 10.1727L63.1489 9.61374Z",
    fill: "#D12027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2389 6.81875C87.2389 6.81875 88.5799 5.25375 87.4059 4.52675C87.4059 4.52675 85.2829 3.52175 84.3879 4.91875C84.3879 4.91875 76.0599 20.0098 75.3339 21.5188C75.3339 21.5188 72.5389 25.9338 67.3409 27.3318C67.3409 27.3318 62.1429 28.5608 59.7959 28.5058C59.7959 28.5058 67.3409 26.6608 69.9119 23.0278C69.9119 23.0278 70.6949 22.1338 72.7069 18.5008C72.7069 18.5008 74.9429 15.0348 76.4519 11.9048C76.4519 11.9048 79.0789 4.97475 83.2149 3.68875C83.2149 3.68875 88.6359 1.39775 90.0899 5.70075C90.1449 5.64475 89.8659 8.10475 87.2389 6.81875Z",
    fill: "#D12027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2632 9.33398L87.0152 16.88C87.0152 16.88 86.6242 20.345 90.2572 20.065C90.2572 20.065 91.5982 19.898 92.1572 19.115C92.1572 19.115 90.0332 19.06 90.5362 17.83L94.7842 9.33398H91.2632Z",
    fill: "#D12027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0881 10.452C99.0881 10.452 100.597 10.117 99.8151 11.737C98.9761 13.358 96.6291 17.327 96.6291 17.327C96.6291 17.327 95.2321 20.233 98.1381 20.177C101.491 20.121 103.56 15.594 103.56 15.594C103.56 15.594 99.8711 19.786 100.262 17.55L103.336 10.731C103.336 10.731 103.615 8.04904 101.268 9.11004C99.0321 10.228 99.0881 10.452 99.0881 10.452Z",
    fill: "#D12027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8477 19.1152C40.8477 19.1152 30.7867 18.5002 44.2017 12.6322L54.8767 9.66919",
    stroke: "#D12027",
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7473 19.2832C53.6473 20.5682 56.8893 18.6682 57.4483 18.1092C57.4483 18.1092 61.0813 14.8112 59.9073 10.4522C59.9073 10.4522 59.1813 9.22222 57.3923 9.83722C57.3923 9.83722 55.7153 12.7992 58.9573 12.4642C60.5783 11.9612 64.8263 7.88122 64.1553 8.66322",
    stroke: "#D12027",
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6519 27.7226C53.1439 30.0146 41.7419 26.6606 40.3449 26.1016C40.3449 26.1016 35.0909 23.6986 40.3449 22.5246C40.3449 22.5246 48.8969 20.7916 64.7699 22.5806C64.7699 22.5806 90.4809 27.2756 98.6409 26.4936C98.6409 26.4936 111.161 26.1016 116.135 18.2216",
    stroke: "#D12027",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4868 19.227C91.4868 19.227 96.9078 14.811 98.6968 7.93697C99.3678 5.36597 95.9028 3.40997 95.8458 8.49597C95.8458 8.49597 95.9028 11.179 99.8148 10.228",
    stroke: "#D12027",
    strokeWidth: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9424 9.50195H84.1644",
    stroke: "#D12027",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 15,
    width: 4,
    height: 4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.123 15.0352H117.7V18.6122H114.123V15.0352Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_555)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.912 15.0352C116.9 15.0352 117.701 15.8362 117.701 16.8242C117.701 17.8112 116.9 18.6122 115.912 18.6122C114.924 18.6122 114.123 17.8112 114.123 16.8242C114.123 15.8362 114.924 15.0352 115.912 15.0352Z",
    fill: "#D12027"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8102 10.3403C43.8102 10.3403 40.5132 11.9613 40.1772 10.4523C39.8422 8.94333 43.2512 9.55733 43.8102 10.2843",
    stroke: "#D12027",
    strokeWidth: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8102 12.3525C89.8102 12.3525 89.8102 10.9555 89.3632 10.5635C88.9152 10.1725 88.0212 10.4525 87.2392 11.3465C86.5122 12.2965 81.5942 18.4445 84.9472 18.1095C84.9472 18.1095 85.7292 18.3885 87.7982 16.0405C87.7982 16.0405 82.6562 23.1955 80.1412 18.3885C80.1412 18.3885 78.7992 15.5945 83.6622 11.1785C83.6622 11.1785 90.1452 6.14849 89.8102 12.3525Z",
    fill: "#D12027"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.522 15.4261C106.522 15.4261 109.987 16.4321 112.111 12.2961C112.111 12.2961 113.173 8.10414 109.876 10.8431C107.025 13.1911 105.851 18.2771 106.578 18.8911C106.578 18.8911 107.919 20.7361 112.67 16.7681C112.67 16.7681 106.633 23.7541 103.56 18.1651C103.56 18.1651 101.715 14.3081 107.192 9.83714C107.192 9.83714 111.608 6.53914 113.005 9.89314C114.347 13.2461 109.093 16.9351 106.522 15.4261Z",
    fill: "#D12027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5377 21.5186H82.8237V21.7426H81.8177V22.3566H82.7117V22.4686H81.8177V23.3076H81.4817V21.5186H81.5377Z",
    fill: "#D12027"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_46_555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 118,
    height: 30
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 28.6399H117.7V-0.00012207H0V28.6399Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_46_555)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.383 23.3069H83.718V21.5179H83.383V23.3069Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4446 23.3071V21.5181H84.7796L85.5626 22.4131C85.7296 22.6371 85.8976 22.8041 86.0096 23.0281C85.9536 22.8041 85.9536 22.5801 85.9536 22.3011V21.5181H86.2336V23.3071H85.8976L85.1146 22.4131C84.9476 22.1891 84.7796 22.0221 84.6676 21.7981V22.5251V23.3071H84.4446Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1892 22.4687H87.2392V23.1397H88.3012V23.3637H86.9602V21.5747H88.2452V21.7987H87.2392V22.3567H88.1892V22.4687Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.754 21.5186H91.04V21.7426H90.033V22.3566H90.928V22.4686H90.033V23.3076H89.698V21.5186H89.754Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.822 22.4131C91.822 22.8041 92.102 23.1401 92.605 23.1401C93.108 23.1401 93.387 22.8041 93.387 22.4131C93.387 22.0781 93.108 21.6861 92.605 21.6861C92.102 21.6301 91.822 22.0221 91.822 22.4131ZM93.722 22.3571C93.722 22.9721 93.219 23.3071 92.605 23.3071C91.99 23.3071 91.543 22.9161 91.543 22.4131C91.543 21.8541 92.046 21.4631 92.66 21.4631C93.276 21.4631 93.722 21.8541 93.722 22.3571Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4489 22.4131C94.4489 22.8041 94.7289 23.1401 95.2319 23.1401C95.7349 23.1401 96.0139 22.8041 96.0139 22.4131C96.0139 22.0781 95.7909 21.6861 95.2319 21.6861C94.7289 21.6301 94.4489 22.0221 94.4489 22.4131ZM96.3489 22.3571C96.3489 22.9721 95.8459 23.3071 95.2319 23.3071C94.6169 23.3071 94.1699 22.9161 94.1699 22.4131C94.1699 21.8541 94.6729 21.4631 95.2869 21.4631C95.9029 21.4631 96.3489 21.8541 96.3489 22.3571Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1877 23.1396H97.5227C98.1937 23.1396 98.5297 22.8606 98.5297 22.3566C98.5297 21.9106 98.1937 21.6866 97.5227 21.6866H97.1317V23.1396H97.1877ZM96.9087 21.5186C97.0757 21.5186 97.2997 21.4626 97.5797 21.4626C98.0257 21.4626 98.3617 21.5186 98.5847 21.6866C98.8087 21.8536 98.9207 22.0216 98.9207 22.3566C98.9207 22.6366 98.8087 22.9156 98.5847 23.0836C98.3617 23.2516 97.9707 23.3636 97.5227 23.3636H96.9637V21.5186H96.9087Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3677 23.0278C99.5347 23.0838 99.7027 23.1398 99.9267 23.1398C100.262 23.1398 100.43 23.0278 100.43 22.8038C100.43 22.6368 100.318 22.5248 99.9827 22.4688C99.5907 22.3568 99.3677 22.1898 99.3677 21.9658C99.3677 21.6868 99.7027 21.4628 100.15 21.4628C100.374 21.4628 100.597 21.5188 100.709 21.5748L100.597 21.7418C100.541 21.6868 100.374 21.6308 100.15 21.6308C99.8147 21.6308 99.7027 21.7988 99.7027 21.9098C99.7027 22.0778 99.8707 22.1898 100.206 22.2448C100.597 22.3568 100.821 22.5248 100.821 22.8038C100.821 23.0838 100.541 23.3068 99.9827 23.3068C99.7587 23.3068 99.4797 23.2518 99.3677 23.1948V23.0278Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.218 21.5186H103.504V21.7426H102.498V22.3566H103.392V22.4686H102.498V23.3076H102.162V21.5186H102.218Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.068 22.5249L104.844 22.0219C104.789 21.9099 104.733 21.7979 104.733 21.6869C104.677 21.7979 104.677 21.9099 104.621 22.0219L104.398 22.5249H105.068ZM104.23 22.7489L103.95 23.3069H103.615L104.453 21.5189H104.844L105.683 23.3069H105.348L105.068 22.7489H104.23Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.187 23.0278C106.354 23.0838 106.522 23.1398 106.746 23.1398C107.081 23.1398 107.249 23.0278 107.249 22.8038C107.249 22.6368 107.137 22.5248 106.802 22.4688C106.411 22.3568 106.187 22.1898 106.187 21.9658C106.187 21.6868 106.522 21.4628 106.969 21.4628C107.193 21.4628 107.416 21.5188 107.528 21.5748L107.416 21.7418C107.361 21.6868 107.193 21.6308 106.969 21.6308C106.634 21.6308 106.522 21.7988 106.522 21.9098C106.522 22.0778 106.69 22.1898 107.025 22.2448C107.416 22.3568 107.64 22.5248 107.64 22.8038C107.64 23.0838 107.361 23.3068 106.802 23.3068C106.578 23.3068 106.299 23.2518 106.187 23.1948V23.0278Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.59 21.6865H107.863V21.4625H109.652V21.6865H108.925V23.3075H108.59V21.6865Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9156 5.86276C19.5826 4.86176 21.7466 5.40076 22.7476 7.06776C23.7486 8.73476 23.2096 10.8978 21.5426 11.8998C19.8756 12.9008 17.7126 12.3618 16.7106 10.6948C15.7086 9.02776 16.2486 6.86376 17.9156 5.86276Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3667 7.71338C16.3667 7.71338 15.2487 10.6194 11.9507 12.4644C11.9507 12.4644 18.8257 13.5824 21.6767 11.7374L16.3667 7.71338Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7716 15.7158C16.6106 13.9618 18.7136 13.2198 20.4676 14.0588C22.2216 14.8988 22.9636 17.0008 22.1246 18.7558C21.2856 20.5098 19.1826 21.2518 17.4286 20.4118C15.6736 19.5728 14.9326 17.4698 15.7716 15.7158Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0998 13.8057C18.0998 13.8057 15.0258 14.4757 11.7278 12.7437C11.7278 12.7437 14.6348 19.1157 17.6528 20.4567L18.0998 13.8057Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6223 0C14.5673 0 16.1433 1.577 16.1433 3.521C16.1433 5.466 14.5673 7.042 12.6223 7.042C10.6773 7.042 9.10132 5.466 9.10132 3.521C9.10132 1.577 10.6773 0 12.6223 0Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9397 5.813C9.9397 5.813 11.8397 8.272 11.7287 12.017C11.7287 12.017 16.1997 6.651 16.1437 3.354L9.9397 5.813Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70814 12.9492C3.37514 11.9482 5.53914 12.4872 6.54014 14.1542C7.54114 15.8212 7.00214 17.9842 5.33514 18.9862C3.66814 19.9872 1.50514 19.4482 0.503142 17.7812C-0.497858 16.1142 0.0411422 13.9502 1.70814 12.9492Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80927 17.103C6.80927 17.103 7.92727 14.197 11.2253 12.353C11.2253 12.353 4.35027 11.234 1.49927 13.079L6.80927 17.103Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.955189 6.08297C1.79419 4.32897 3.89719 3.58697 5.65119 4.42597C7.40619 5.26597 8.14719 7.36797 7.30819 9.12297C6.46919 10.877 4.36619 11.619 2.61219 10.779C0.857189 9.93997 0.116189 7.83697 0.955189 6.08297Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02051 11.0107C5.02051 11.0107 8.09451 10.3407 11.3925 12.0727C11.3925 12.0727 8.48551 5.70074 5.46751 4.35974L5.02051 11.0107Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4983 17.6621C12.4433 17.6621 14.0193 19.2391 14.0193 21.1831C14.0193 23.1281 12.4433 24.7041 10.4983 24.7041C8.55329 24.7041 6.97729 23.1281 6.97729 21.1831C6.97729 19.2391 8.55329 17.6621 10.4983 17.6621Z",
    fill: "#D12027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1813 18.9477C13.1813 18.9477 11.2813 16.4887 11.3923 12.7437C11.3923 12.7437 6.92133 18.1097 6.97733 21.4067L13.1813 18.9477Z",
    fill: "#D12027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b34c114ff8f48088866b2e1aa2b8d60.svg";
export { ForwardRef as ReactComponent };